import { Footer } from '@/components/Footer';
import { Header } from '@/components/Header';
import { LogoStrip } from '@/components/LogoStrip';
import { SeoJsonLd } from '@/components/SeoJsonLd';
import { WhatsAppFloatingButton } from '@/components/WhatsAppFloatingButton';
import { useHashScrollOnLoad } from '@/hooks/useHashScrollOnLoad';
import { useScrollDepth } from '@/hooks/useScrollDepth';
import { useSectionViews } from '@/hooks/useSectionViews';
import { AgentTraining } from '@/sections/AgentTraining';
import { Channels } from '@/sections/Channels';
import { ComparisonTable } from '@/sections/ComparisonTable';
import { Faq } from '@/sections/Faq';
import { FeaturesGrid } from '@/sections/FeaturesGrid';
import { Hero } from '@/sections/Hero';
import { Operators } from '@/sections/Operators';
import { PainPoints } from '@/sections/PainPoints';
import { Pillars } from '@/sections/Pillars';
import { Pricing } from '@/sections/Pricing';
import { ProductShowcase } from '@/sections/ProductShowcase';
import { SocialProof } from '@/sections/SocialProof';
import { Testimonials } from '@/sections/Testimonials';
import { WorkflowCalendar } from '@/sections/WorkflowCalendar';

export function LandingPage() {
  useScrollDepth();
  useSectionViews();
  useHashScrollOnLoad();

  return (
    <div className="landing-entry">
      <SeoJsonLd />
      <Header />
      <Hero />
      <LogoStrip />

      <main>
        <div className="mesh-bg-entry" aria-hidden />
        <PainPoints />
        <ProductShowcase />
        <Pillars />
        <AgentTraining />
        <FeaturesGrid />
        <Channels />
        <WorkflowCalendar />
        <Operators />
        <SocialProof />
        <Testimonials />
        <ComparisonTable />
        <Pricing />
        <Faq />
      </main>

      <Footer />
      <WhatsAppFloatingButton />
    </div>
  );
}
